function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#151E2C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5033 8L31 30.4078L44.5033 24.2705V8Z",
  fill: "#8A92B2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5033 24.2703L31 30.4076L44.5033 38.3915V24.2703Z",
  fill: "#62688F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.0087 30.4078L44.5029 8V24.2705L58.0087 30.4078Z",
  fill: "#62688F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5029 38.3915L58.0087 30.4076L44.5029 24.2703V38.3915Z",
  fill: "#454A75"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31 32.97L44.5033 52.0001V40.9488L31 32.97Z",
  fill: "#8A92B2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5029 40.9488V52.0001L58.0162 32.97L44.5029 40.9488Z",
  fill: "#62688F"
});

var SvgEth = function SvgEth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ETH.16861aa0.svg";
export { ForwardRef as ReactComponent };